import { c as _c } from "react/compiler-runtime";
// Вход через Яндекс ID и VK ID (ТЗ, п. 1.2) - под кнопкой «Получить код» на
// карточке входа. Макет авторизации кнопок не рисует, поэтому это вторичное
// действие в языке карточки: разделитель «или» и белые кнопки 48 r12 с
// обводкой, как поля формы. Провайдеры приходят со шлюза - без ключей список
// пуст и блока нет вовсе.
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { api, type OAuthProviderId, type OAuthProviderInfo } from "@/api";
import { cn } from "@/lib/utils";
let providersOnce: Promise<OAuthProviderInfo[]> | null = null;
const loadProviders = () => {
  providersOnce ??= api.oauth.providers().catch(() => {
    providersOnce = null;
    return [];
  });
  return providersOnce;
};
export function useOAuthProviders() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [providers, setProviders] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      let alive = true;
      loadProviders().then(list => alive && setProviders(list));
      return () => {
        alive = false;
      };
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return providers;
}
export function OAuthProviderIcon(t0) {
  const $ = _c(12);
  const {
    provider,
    className
  } = t0;
  if (provider === "yandex") {
    let t1;
    if ($[0] !== className) {
      t1 = cn("size-6 shrink-0", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <circle cx="12" cy="12" r="12" fill="#FC3F1D" />;
      t3 = <path fill="#fff" d="M13.32 18.5h2.08V5.5h-3.03c-3.04 0-4.64 1.56-4.64 3.86 0 1.84.88 2.92 2.44 4.04L7.47 18.5h2.25l3-4.5-1.04-.7c-1.26-.85-1.87-1.52-1.87-2.95 0-1.26.88-2.11 2.57-2.11h.94z" />;
      $[2] = t2;
      $[3] = t3;
    } else {
      t2 = $[2];
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t1) {
      t4 = <svg viewBox="0 0 24 24" aria-hidden="true" className={t1}>{t2}{t3}</svg>;
      $[4] = t1;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("size-6 shrink-0", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect width="24" height="24" rx="7" fill="#0077FF" />;
    t3 = <path fill="#fff" d="M12.77 17c-4.96 0-7.79-3.4-7.91-9.06h2.49c.08 4.15 1.91 5.91 3.36 6.27V7.94h2.34v3.58c1.43-.15 2.94-1.78 3.45-3.58h2.34c-.39 2.2-2.02 3.83-3.18 4.5 1.16.54 3.02 1.96 3.73 4.56h-2.58c-.55-1.73-1.93-3.07-3.76-3.25V17z" />;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1) {
    t4 = <svg viewBox="0 0 24 24" aria-hidden="true" className={t1}>{t2}{t3}</svg>;
    $[10] = t1;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}

/** Уйти к провайдеру. mode=link - привязка из профиля (нужен вход). */
export async function goToOAuth(provider: OAuthProviderInfo, mode: "login" | "link", returnTo: string, failText: string): Promise<void> {
  try {
    const {
      url
    } = await api.oauth.start(provider.id, {
      mode,
      returnTo
    });
    window.location.assign(url);
  } catch {
    toast.error(failText);
  }
}
export function OAuthButtons(t0) {
  const $ = _c(22);
  const {
    consent,
    onNeedConsent
  } = t0;
  const {
    t
  } = useTranslation();
  const providers = useOAuthProviders();
  const [busy, setBusy] = useState(null);
  if (!providers.length) {
    return null;
  }
  let t1;
  if ($[0] !== consent || $[1] !== onNeedConsent || $[2] !== t) {
    t1 = async p => {
      if (!consent) {
        onNeedConsent();
        toast.error(t("oauth.needConsent"));
        return;
      }
      setBusy(p.id);
      const returnTo = `${window.location.pathname}${window.location.search}`;
      await goToOAuth(p, "login", returnTo.startsWith("/auth/oauth") ? "/" : returnTo, t("oauth.startFailed", {
        provider: p.title
      }));
      setBusy(null);
    };
    $[0] = consent;
    $[1] = onNeedConsent;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const go = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="h-px flex-1 bg-[#1F1F1F]/12" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("oauth.or");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="h-px flex-1 bg-[#1F1F1F]/12" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <div className="flex items-center gap-3 text-[14px] leading-[18px] text-[#1F1F1F]/48">{t2}{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== busy || $[11] !== go || $[12] !== providers || $[13] !== t) {
    let t7;
    if ($[15] !== busy || $[16] !== go || $[17] !== t) {
      t7 = p_0 => <button key={p_0.id} type="button" data-testid={`oauth-${p_0.id}`} disabled={busy !== null} onClick={() => void go(p_0)} className="flex h-12 w-full items-center justify-center gap-2.5 rounded-[12px] border border-[#1F1F1F]/12 bg-white px-4 text-[16px] leading-[21px] font-semibold text-[#2E2E2E] outline-none transition-colors hover:bg-[#1F1F1F]/[0.03] focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40 disabled:opacity-60"><OAuthProviderIcon provider={p_0.id} />{t("oauth.signInWith", {
          provider: p_0.title
        })}</button>;
      $[15] = busy;
      $[16] = go;
      $[17] = t;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    t6 = providers.map(t7);
    $[10] = busy;
    $[11] = go;
    $[12] = providers;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className="flex flex-col gap-3" data-testid="oauth-buttons">{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}